import {
  Box,
  IconButton,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const StepAccordion = styled(Accordion)({
  border: '1px solid var(--am-border)',
  borderRadius: '8px !important',
  background: 'transparent',

  '&:before': { display: 'none' },
});

export const StepAccordionSummary = styled(AccordionSummary)({
  padding: '0 16px',
  backgroundColor: 'var(--am-surface)',
  borderRadius: '8px 8px 0 0',

  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    gap: 8,
    margin: '8px 0',
  },
});

export const ReorderButtonsBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
});

export const StepTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: '14px',
  flex: 1,
  color: 'var(--am-text-primary)',
});

export const StepAccordionDetails = styled(AccordionDetails, {
  shouldForwardProp: (prop) => prop !== 'compactContent',
})<{ compactContent?: boolean }>(({ compactContent }) => ({
  padding: compactContent ? '0 16px 44px' : '0 16px 20px',
  position: 'relative',
}));

export const StepContentBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
});

export const ScriptTextArea: typeof Box = styled(Box)(({ theme }) => ({
  width: '100%',
  resize: 'vertical',
  fontFamily: 'inherit',
  fontSize: '15px',
  padding: '8px 10px',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid var(--am-border-mid)',
  color: 'var(--am-text-primary)',
  backgroundColor: 'var(--am-input-bg)',
  boxSizing: 'border-box',

  '&:focus': {
    outline: 'none',
    borderColor: theme.palette.primary.main,
  },
})) as typeof Box;

export const ScriptTextHintIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
  fontSize: 15,
  color: theme.palette.primary.main,
  opacity: 0.75,
  cursor: 'default',
  marginBottom: 9,
}));

export const DeleteStepButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: 8,
  right: 8,
  color: 'var(--am-text-secondary)',

  '&:hover': { color: theme.palette.error.main },
}));

export const BaseTextBox = styled(Box)({
  width: '100%',
  height: '88px',
  overflowY: 'auto',
  padding: '8px 10px',
  borderRadius: '4px',
  border: '1px solid var(--am-border)',
  backgroundColor: 'var(--am-surface)',
  fontSize: '14px',
  color: 'var(--am-text-secondary)',
  fontStyle: 'italic',
  lineHeight: 1.5,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  boxSizing: 'border-box',
});

export const BaseLangLabel = styled(Typography)({
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--am-text-disabled)',
  marginBottom: 4,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
}) as typeof Typography;
